import { render, staticRenderFns } from "./CreditCard.vue?vue&type=template&id=36c8d704&"
import script from "./CreditCard.vue?vue&type=script&lang=js&"
export * from "./CreditCard.vue?vue&type=script&lang=js&"
import style0 from "./CreditCard.vue?vue&type=style&index=0&id=36c8d704&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports